export default `
I'm a computer scientist who knows more than just 1s and 0s.
Always inspired by various subjects hence why I chose software engineer as my career.
CS is great for its flexibility where its skill set can be applied in vastly different industries.
`;



// WEBPACK FOOTER //
// ./src/components/about/portrait/about-me.ts